<form #form="ngForm">
    <div class="app-grid">
        <mat-form-field *ngIf="!profile" class="columns-6 small-columns-12">
            <mat-label>{{ 'performance.feedbackCreationModal.colleagueLabel' | translate }}</mat-label>
            <ui-employee-autocomplete
                [(ngModel)]="feedback.subject"
                name="subject"
                required
                #subject="ngModel"
            ></ui-employee-autocomplete>
            <mat-error *ngIf="subject.invalid">{{ subject.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="profile" class="columns-6 small-columns-12">
            <mat-label>{{ 'performance.feedbackCreationModal.colleagueLabel' | translate }}</mat-label>
            <input matInput class="read-only" disabled [value]="profile?.fullName" />
        </mat-form-field>

        <mat-form-field class="columns-6 small-columns-12">
            <mat-label>{{ 'performance.feedbackCreationModal.titleLabel' | translate }}</mat-label>
            <input
                matInput
                type="text"
                required
                name="title"
                [(ngModel)]="feedback.title"
                #title="ngModel"
                placeholder="{{ 'performance.feedbackCreationModal.titlePlaceholder' | translate }}"
            />
            <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-6 small-columns-12">
            <mat-label appRemoveAriaOwns>{{
                'performance.feedbackCreationModal.visiblityLabel' | translate
            }}</mat-label>
            <mat-select
                name="visiblity"
                #visibility="ngModel"
                required
                [(ngModel)]="feedback.visibility"
                placeholder="{{ 'performance.feedbackCreationModal.visiblityPlaceholder' | translate }}"
            >
                <mat-option value="public">{{ 'performance.feedbackVisibilities.public' | translate }}</mat-option>
                <mat-option value="private">{{ 'performance.feedbackVisibilities.private' | translate }}</mat-option>
                <mat-option value="manager">{{ 'performance.feedbackVisibilities.manager' | translate }}</mat-option>
                <mat-option *permission="'administrate'" value="admin">{{
                    'performance.feedbackVisibilities.admin' | translate
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="visibility.invalid">{{ visibility.errors | formErrors }}</mat-error>
        </mat-form-field>

        <div class="columns-6 small-columns-12">
            <ng-container [ngSwitch]="feedback.visibility">
                <ng-container *ngSwitchCase="'public'">
                    <h4>{{ 'performance.feedbackCreationModal.publicVisibilityNote' | translate }}</h4>
                </ng-container>

                <ng-container *ngSwitchCase="'private'">
                    <h4>{{ 'performance.feedbackCreationModal.privateVisibilityNote' | translate }}</h4>
                </ng-container>

                <ng-container *ngSwitchCase="'manager'">
                    <h4>{{ 'performance.feedbackCreationModal.managerVisibilityNote' | translate }}</h4>
                </ng-container>

                <ng-container *ngSwitchCase="'admin'">
                    <h4>{{ 'performance.feedbackCreationModal.adminVisibilityNote' | translate }}</h4>
                </ng-container>
            </ng-container>
        </div>

        <div class="columns-12 sentiment-wrapper">
            <mat-label>{{ 'performance.feedbackCreationModal.sentimentLabel' | translate }}</mat-label>

            <div class="sentiment-selector app-grid">
                <div
                    class="sentiment positive columns-4"
                    [class.selected]="feedback.positive"
                    (click)="updateSentimentToggle('positive')"
                >
                    <span class="emoji">👍</span>
                    <h3 class="ui header">{{ 'performance.feedbackTypes.positive' | translate }}</h3>
                </div>

                <div
                    class="sentiment constructive columns-4"
                    [class.selected]="feedback.constructive"
                    (click)="updateSentimentToggle('constructive')"
                >
                    <span class="emoji">✏</span>
                    <h3 class="ui header">{{ 'performance.feedbackTypes.constructive' | translate }}</h3>
                </div>

                <div
                    class="sentiment managers-note columns-4"
                    [class.selected]="feedback.negative"
                    (click)="updateSentimentToggle('negative')"
                >
                    <span class="emoji">📋</span>
                    <h3 class="ui header">{{ 'performance.feedbackTypes.negative' | translate }}</h3>
                </div>
            </div>
        </div>

        <mat-form-field class="columns-12">
            <mat-label>{{ 'performance.feedbackCreationModal.bodyLabel' | translate }}</mat-label>
            <ui-rich-text name="feedbackBodyRichText" [(ngModel)]="feedback.body" height="150px"></ui-rich-text>
        </mat-form-field>
    </div>
</form>
